// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"389":"50cc206e","458":"e376f40b","608":"c8cf7655"}[chunkId] + ".chunk.js";
};